'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import HtzLink from '@haaretz/s-htz-link';
import useBi from '@haaretz/s-use-bi';
export default function ExtraLinkClient({ link, listTitle }) {
    const biAction = useBi();
    return link.url ? /*#__PURE__*/ _jsx(HtzLink, {
        onClick: ()=>{
            biAction({
                action_id: 153,
                feature: 'content list',
                feature_type: 'Content',
                campaign_name: listTitle,
                campaign_details: link.title ?? ''
            });
        },
        href: link.url,
        children: link.title
    }) : null;
}

//# sourceMappingURL=ExtraLink.client.js.map